(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7699,2278],{

/***/ 78298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z"
}), 'ArrowBackIosNew');

exports.Z = _default;

/***/ }),

/***/ 35119:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44zM3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4 4.97 0 9-4.03 9-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67V21zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3c-4.97 0-9 4.03-9 9H1z"
}), 'CurrencyExchangeOutlined');

exports.Z = _default;

/***/ }),

/***/ 75767:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M18 23H4c-1.1 0-2-.9-2-2V7h2v14h14v2zM14.5 7V5h-2v2h-2v2h2v2h2V9h2V7h-2zm2 6h-6v2h6v-2zM15 1H8c-1.1 0-1.99.9-1.99 2L6 17c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V7l-6-6zm4 16H8V3h6.17L19 7.83V17z"
}), 'DifferenceOutlined');

exports.Z = _default;

/***/ }),

/***/ 83733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 7h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zM1 11v10h6v-5h2v5h6V11L8 6l-7 5zm12 8h-2v-5H5v5H3v-7l5-3.5 5 3.5v7z"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z"
}, "1")], 'MapsHomeWorkOutlined');

exports.Z = _default;

/***/ }),

/***/ 30120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61354);
/* harmony import */ var _className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18356);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76281);




const defaultTheme = (0,_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
const Box = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: _className__WEBPACK_IMPORTED_MODULE_2__/* ["default"].generate */ .Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Box);

/***/ }),

/***/ 20397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/recetas",
      function () {
        return __webpack_require__(13021);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CheckoutPrescriptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _screens_checkout_prescriptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22278);


function CheckoutPrescriptions() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_checkout_prescriptions__WEBPACK_IMPORTED_MODULE_1__.CheckoutPrescriptionsPage, {
        redirectOnNonePending: true
    });
}


/***/ }),

/***/ 61912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LE": function() { return /* binding */ SubtitleTypography; },
/* harmony export */   "Mm": function() { return /* binding */ SubmitButton; },
/* harmony export */   "OO": function() { return /* binding */ ContentContainer; },
/* harmony export */   "Xl": function() { return /* binding */ InputDiv; },
/* harmony export */   "ap": function() { return /* binding */ PhonePrefixSelect; },
/* harmony export */   "c7": function() { return /* binding */ TitleContainer; },
/* harmony export */   "dP": function() { return /* binding */ TitleTypography; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "oi": function() { return /* binding */ TextInput; },
/* harmony export */   "sh": function() { return /* binding */ FormMainCard; },
/* harmony export */   "up": function() { return /* binding */ UrlSpan; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67836);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53442);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26993);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _BaseStyles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8347);




var FormMainCard = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_BaseStyles__WEBPACK_IMPORTED_MODULE_0__/* .MainCard */ .A)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "100%",
        minHeight: "100dvh",
        borderRadius: 0,
        padding: "40px 24px 32px 24px",
        overflow: "hidden"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("sm"), {
        padding: "96px 16px 32px 16px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
        maxWidth: "800px",
        minHeight: "620px",
        padding: "56px",
        borderRadius: "10px"
    }), _obj;
});
var Form = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("form")({
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    maxWidth: "450px",
    width: "100%",
    alignItems: "center"
});
var TitleContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme, width = param.width;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: width || "100%"
    }, theme.breakpoints.up("sm"), {
        padding: "0 24px"
    });
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: theme.palette.text.primary
    }, theme.breakpoints.up("sm"), {
        fontSize: "24px",
        lineHeight: "36px",
        textAlign: "center"
    });
});
var SubtitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "21px",
        letterSpacing: "0.15px",
        color: theme.palette.text.secondary
    }, theme.breakpoints.up("sm"), {
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "center"
    });
});
var ContentContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%"
    }, theme.breakpoints.up("sm"), {
        padding: "0 24px",
        gap: "24px"
    });
});
var InputDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row"
});
var TextInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    width: "100%",
    "& .MuiOutlinedInput-root": {
        height: "48px"
    },
    "& .MuiInputLabel-root": {
        top: "-4px"
    },
    "& .MuiFormHelperText-root": {
        minHeight: "20px"
    },
    "& input:-webkit-autofill": {
        height: "14px"
    }
});
var PhonePrefixSelect = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    width: "150px",
    marginRight: "10px",
    height: "48px"
});
var SubmitButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    padding: "9px 60px",
    backgroundColor: "#0A7ABE",
    borderRadius: "100px",
    border: "none",
    transition: "all 0.3s ease-in-out",
    color: "white",
    "&:hover": {
        backgroundColor: "#0A7ABE"
    },
    "&:disabled": {
        backgroundColor: "#EAEAEA",
        color: "#AFAFAF"
    },
    textTransform: "none",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    fontSize: "16px"
});
var UrlSpan = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span")({
    color: "#0A7ABE",
    textDecoration: "underline",
    cursor: "pointer"
});


/***/ }),

/***/ 45629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ SimpleHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/components/Header/SimpleHeader.styles.ts


var RootDiv = (0,styled/* default */.Z)(AppBar/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "backgroundColor";
    }
})(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        zIndex: 100,
        top: 0,
        bottom: "auto",
        height: "64px",
        padding: "0 24px",
        backgroundColor: backgroundColor || theme.palette.primary.dark,
        color: "#414046",
        boxShadow: "0px 1px 10px rgb(0 0 0 / 12%)"
    };
});
var CenteredWrapper = (0,styled/* default */.Z)(Box/* default */.Z)({
    marginTop: "4px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "19px",
    lineHeight: "28.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center"
});
var LeftActionContainer = (0,styled/* default */.Z)("div")({
    position: "absolute",
    left: 24
});

// EXTERNAL MODULE: ./src/components/icons/LogoMeki.tsx
var LogoMeki = __webpack_require__(73604);
// EXTERNAL MODULE: ./src/utils/routes.ts
var routes = __webpack_require__(68139);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIosNew.js
var ArrowBackIosNew = __webpack_require__(78298);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
;// CONCATENATED MODULE: ./src/components/Header/SimpleHeader.tsx









var backgroundColorMap = function(theme) {
    return {
        blue: theme.palette.primary.dark,
        white: "#fff"
    };
};
function SimpleHeader(param) {
    var _backButton = param.backButton, backButton = _backButton === void 0 ? false : _backButton, parentHandleBack = param.handleBack, _homeButton = param.homeButton, homeButton = _homeButton === void 0 ? false : _homeButton, _homeButtonColor = param.homeButtonColor, homeButtonColor = _homeButtonColor === void 0 ? "black" : _homeButtonColor, _title = param.title, title = _title === void 0 ? null : _title, _color = param.color, color = _color === void 0 ? "blue" : _color;
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var backgroundColor = backgroundColorMap(theme)[color];
    var handleBack = (0,react.useCallback)(function() {
        if (parentHandleBack) {
            parentHandleBack();
        } else if (window.history.length > 2) {
            router.back();
        } else {
            router.push((0,routes/* getRoute */.Bv)("homeLoggedIn").toString());
        }
    }, [
        router,
        parentHandleBack
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftActionContainer, {
                children: backButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    size: "small",
                    color: "inherit",
                    "aria-label": "back",
                    onClick: handleBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIosNew/* default */.Z, {})
                }) : !homeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: (0,routes/* getRoute */.Bv)("homeLoggedIn").toString(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMeki/* MekiLogo */.$, {
                        height: "20px",
                        width: "auto",
                        fill: homeButtonColor
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    homeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: (0,routes/* getRoute */.Bv)("homeLoggedIn").toString(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CenteredWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMeki/* MekiLogo */.$, {
                                height: "20px",
                                width: "auto",
                                fill: homeButtonColor
                            })
                        })
                    }),
                    !homeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                            children: title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
}


/***/ }),

/***/ 69029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ InformationBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js
var Box = __webpack_require__(18377);
;// CONCATENATED MODULE: ./src/screens/checkout/components/InformationBox.styles.ts


var RootDiv = (0,styled/* default */.Z)(Box/* default */.Z)({
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px",
    backgroundColor: "#E6F3FA",
    color: "#003654"
});
var ImgDiv = (0,styled/* default */.Z)(Box/* default */.Z)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    width: "24px",
    height: "24px"
});
var TextDiv = (0,styled/* default */.Z)(Box/* default */.Z)({
    display: "flex",
    flexDirection: "column",
    gap: "4px"
});
var Title = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "15.6px",
    letterSpacing: "0.15px"
});
var InformationText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.15px",
    "& span": {
        fontWeight: "600"
    }
});

;// CONCATENATED MODULE: ./src/screens/checkout/components/InformationBox.tsx


var InformationBox = function(param) {
    var title = param.title, information = param.information, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextDiv, {
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    information && /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationText, {
                        children: information
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 79728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CheckoutTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91655);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58055);



var CheckoutTitle = function(param) {
    var title = param.title, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "rectangular",
                width: 240,
                height: 36
            }),
            !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_1__/* .TitleTypography */ .dP, {
                children: title
            })
        ]
    });
};


/***/ }),

/***/ 22278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CheckoutPrescriptionsPage": function() { return /* binding */ CheckoutPrescriptionsPage; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/queries/order/queries/currentOrderWithPrescriptions.ts
var currentOrderWithPrescriptions = __webpack_require__(3073);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/prescriptions/UploadImage.tsx + 2 modules
var UploadImage = __webpack_require__(99388);
// EXTERNAL MODULE: ./src/components/BaseStyles.ts
var BaseStyles = __webpack_require__(8347);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/components/PrescriptionsInfoCard.styles.ts




var PrescriptionsInfoMainCard = (0,styled/* default */.Z)(BaseStyles/* MainCard */.A)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "24px",
        minWidth: "240px",
        width: "100%"
    }, theme.breakpoints.up("md"), {
        maxWidth: "360px",
        minHeight: "360px"
    });
});
var PrescriptionsInfoContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "32px"
});
var PrescriptionsInfoItem = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px"
});
var PrescriptionsInfoText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0.16px",
        color: theme.palette.text.secondary
    };
});

// EXTERNAL MODULE: ./src/screens/checkout/styles.ts
var styles = __webpack_require__(58055);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DifferenceOutlined.js
var DifferenceOutlined = __webpack_require__(75767);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CurrencyExchangeOutlined.js
var CurrencyExchangeOutlined = __webpack_require__(35119);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MapsHomeWorkOutlined.js
var MapsHomeWorkOutlined = __webpack_require__(83733);
;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/components/PrescriptionsInfoCard.tsx






var PrescriptionsInfoCard = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrescriptionsInfoMainCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TitleTypography */.dP, {
                children: "\xbfQu\xe9 haremos con tu receta?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrescriptionsInfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrescriptionsInfoItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DifferenceOutlined/* default */.Z, {
                                "aria-label": "Receta revisada por farmac\xe9uticos"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrescriptionsInfoText, {
                                children: "Al terminar la compra tu receta ser\xe1 revisada por nuestros qu\xedmicos farmac\xe9uticos."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrescriptionsInfoItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MapsHomeWorkOutlined/* default */.Z, {
                                "aria-label": "Retiro de receta a domicilio"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrescriptionsInfoText, {
                                children: "De ser necesario, retiraremos el documento original al momento del despacho."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrescriptionsInfoItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyExchangeOutlined/* default */.Z, {
                                "aria-label": "Reembolso en caso de rechazo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrescriptionsInfoText, {
                                children: "En caso de que sea rechazada, te contactaremos para gestionar el reembolso."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/components/Item.styles.ts



var RootDiv = (0,styled/* default */.Z)("div")({
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    padding: "12px",
    borderBottom: "1px solid #EAEAEA",
    alignItems: "center",
    height: "104.5px",
    position: "relative",
    ":last-child": {
        borderRadius: "0 0 10px 10px",
        borderBottom: "none"
    }
});
var ProductQuantity = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0 20px"
});
var VerticalLine = (0,styled/* default */.Z)("hr")({
    height: "104.5px",
    margin: 0,
    border: "1px solid #EAEAEA",
    position: "absolute",
    marginLeft: "60px"
});
var ImgDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    width: "80px",
    justifyContent: "center",
    marginLeft: "30px",
    height: "inherit",
    alignItems: "center"
});
var ImgProduct = (0,styled/* default */.Z)("img")({
    width: "100%",
    display: "block",
    objectFit: "contain",
    maxHeight: "80%"
});
var SkeletonQuantity = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "20px",
    height: "20px",
    marginLeft: "10px",
    marginRight: "50px"
});
var SkeletonImg = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "5rem",
    height: "5rem"
});
var SkeletonText = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "130px",
    height: "80px",
    marginLeft: "16px"
});
var DetailRootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    maxWidth: "200px",
    minWidth: "100px",
    paddingBottom: 0,
    padding: "0 10px 0px 12px",
    "@media (min-width: 450px)": {
        flex: 1,
        maxWidth: "90%"
    }
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    maxWidth: "200px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#414046",
    "@media (min-width: 450px)": {
        maxWidth: "90%"
    }
});
var DetailsTextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#757475",
    span: {
        color: "#414046"
    }
});
var DetailsPriceDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    marginTop: "1px"
});
var DetailsPriceTypographyBold = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var DetailsPriceTypographyLight = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});

// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/components/Item.tsx







var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
});
function Item(param) {
    var product = param.product, price = param.price, quantity = param.quantity;
    var ref = (0,react.useState)(product.imagesUrl[0]), imageUrl = ref[0], setImageUrl = ref[1];
    var handleImageError = function() {
        setImageUrl("/assets/images/default.webp");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantity, {
                children: quantity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgProduct, {
                    src: imageUrl,
                    onError: handleImageError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailRootDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        variant: "subtitle2",
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                        children: (0,extractExtraInfo/* extractExtraInfo */.UD)(product)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                        children: product.laboratory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPriceTypographyBold, {
                                children: quantity > 1 && "".concat(currFormat.format(price * quantity), "・")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceTypographyLight, {
                                children: [
                                    "".concat(currFormat.format(price)),
                                    "/un"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/components/ItemsList.styles.ts


var ItemsList_styles_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var isDelivery = param.isDelivery;
    return {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        borderRadius: "10px",
        margin: isDelivery ? "17px 0px 0 0" : "17px 0px 97px 0"
    };
});
var ItemsList_styles_TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#414046",
    marginBottom: "12px",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "12px"
});
var SubTitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#414046",
    marginBottom: "12px",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "12px"
});
var DivisionLine = (0,styled/* default */.Z)("div")({
    height: "1px",
    backgroundColor: "#EAEAEA"
});


;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/components/ItemsList.tsx




var prescriptionName = {
    NOT_REQUIRED: "Receta simple",
    HELD: "Receta retenida",
    SIMPLE: "Receta simple",
    CHECK: "Receta cheque"
};
function ItemsList(param) {
    var productsByPrescription = param.productsByPrescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList_styles_RootDiv, {
        isDelivery: true,
        children: productsByPrescription === null || productsByPrescription === void 0 ? void 0 : productsByPrescription.map(function(item, index) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleTypography, {
                        children: prescriptionName[item === null || item === void 0 ? void 0 : item[0]]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DivisionLine, {}),
                    item === null || item === void 0 ? void 0 : (ref = item[1]) === null || ref === void 0 ? void 0 : ref.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            product: product,
                            price: product.price,
                            quantity: +product.quantity
                        }, index);
                    })
                ]
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./src/components/Loader.tsx
var Loader = __webpack_require__(76931);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
// EXTERNAL MODULE: ./src/components/Header/SimpleHeader.tsx + 1 modules
var SimpleHeader = __webpack_require__(45629);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/components/FormComponents.ts
var FormComponents = __webpack_require__(61912);
// EXTERNAL MODULE: ./src/screens/checkout/components/Title.tsx
var Title = __webpack_require__(79728);
;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/styles.ts


var UploadImageContainer = (0,styled/* default */.Z)(BaseStyles/* MainCard */.A)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "16px",
    gap: "16px"
});

// EXTERNAL MODULE: ./src/screens/checkout/components/InformationBox.tsx + 1 modules
var InformationBox = __webpack_require__(69029);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
;// CONCATENATED MODULE: ./src/screens/checkout/prescriptions/index.tsx






























function CheckoutPrescriptionsPage(param) {
    var redirectOnNonePending = param.redirectOnNonePending;
    var ref;
    var isDesktop = (0,useWindowSize/* useWindowSize */.i)().isDesktop;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var router = (0,next_router.useRouter)();
    var _query = router.query, code = _query.codigo;
    var codeString = code ? decodeURI(code) : "";
    var appUser = (0,useAuth/* useAuth */.a)({
        forceAuth: true
    }).appUser;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var ref1 = (0,react.useState)(true), loadingUser = ref1[0], setLoadingUser = ref1[1];
    var ref2 = (0,react.useState)(false), emptyImagesError = ref2[0], setEmptyImagesError = ref2[1];
    void track(Screen/* ScreenEventType.ScreenCheckoutPrescriptionsView */.O.ScreenCheckoutPrescriptionsView);
    var ref3 = (0,useQuery/* useQuery */.a)((0,currentOrderWithPrescriptions/* currentOrderWithPrescriptions */.l)(), {
        returnPartialData: true,
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), currentOrderData = ref3.data, loadingCurrentOrder = ref3.loading, error = ref3.error;
    var currentOrder = currentOrderData === null || currentOrderData === void 0 ? void 0 : currentOrderData.currentOrder;
    var pendingPrescriptions = currentOrderData === null || currentOrderData === void 0 ? void 0 : currentOrderData.pendingPrescriptions;
    var ref4 = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)(), requirePrescriptions = ref4.requirePrescriptions, requirePrescriptionUpload = ref4.requirePrescriptionUpload, prescriptionLoading = ref4.loading, associatedPrescriptions = ref4.associatedPrescriptions;
    var products = (0,react.useMemo)(function() {
        return currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails.filter(function(detail) {
            return detail.product.prescriptionType && detail.product.prescriptionType !== "NOT_REQUIRED";
        }).map(function(detail) {
            return detail.product;
        });
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails
    ]);
    var productsByPrescriptionType = (0,react.useMemo)(function() {
        if (!isLocalVendor) return null;
        return currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails.reduce(function(acc, detail) {
            var ref;
            var prescriptionType = detail === null || detail === void 0 ? void 0 : (ref = detail.product) === null || ref === void 0 ? void 0 : ref.prescriptionType;
            if (prescriptionType) {
                var typeKey = prescriptionType == "NOT_REQUIRED" ? "SIMPLE" : prescriptionType;
                if (acc[typeKey]) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, typeKey, (0,_to_consumable_array/* default */.Z)(acc[typeKey]).concat([
                        (0,_object_spread/* default */.Z)({
                            price: detail.price,
                            quantity: detail.quantity
                        }, detail.product), 
                    ])));
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, typeKey, [
                    (0,_object_spread/* default */.Z)({
                        price: detail.price,
                        quantity: detail.quantity
                    }, detail.product), 
                ]));
            }
            return acc;
        }, {});
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails,
        isLocalVendor
    ]);
    var prescriptionsUploaded = (0,react.useMemo)(function() {
        return (pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length) > 0;
    }, [
        pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length
    ]);
    var handleNext = (0,react.useCallback)(function() {
        if (isLocalVendor) {
            void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentMethodLocal"));
        }
        if (!products) {
            // void track('prescription press next without products', {
            //   products,
            // });
            return;
        }
        if (!prescriptionsUploaded && requirePrescriptionUpload && associatedPrescriptions.length === 0) {
            utils/* Console.log */.Mn.log("No prescriptions uploaded");
            setEmptyImagesError(true);
            return;
        }
        // void track('confirm_prescriptions', {
        //   uploaded_prescription_amount: pendingPrescriptions?.length,
        // });
        // void track('prescription upload', {
        //   uploaded_prescription_amount: pendingPrescriptions?.length,
        //   products_amount: products?.length,
        //   prescription_types: Array.from(
        //     new Set(products.map((e) => e.prescriptionType)) ?? [],
        //   ),
        // });
        void router.push((0,utils/* getRoute */.Bv)("checkoutPaymentConfirm"));
    }, [
        isLocalVendor,
        products,
        prescriptionsUploaded,
        requirePrescriptionUpload,
        associatedPrescriptions.length,
        router, 
    ]);
    (0,react.useEffect)(function() {
        if (appUser) {
            setLoadingUser(false);
        }
    }, [
        appUser
    ]);
    (0,react.useEffect)(function handleNoPrescriptionNeeded() {
        var ref;
        if (appUser && !loadingCurrentOrder && (!currentOrder || (currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.orderDetails) === null || ref === void 0 ? void 0 : ref.length) === 0) && redirectOnNonePending) {
            void router.replace((0,utils/* getRoute */.Bv)("cart"));
            return;
        }
        if (prescriptionLoading || loadingCurrentOrder || error || !products) return;
        // void track('prescription request', {
        //   products_amount: products.length,
        //   prescription_types: Array.from(
        //     new Set(products.map((e) => e.prescriptionType)) ?? [],
        //   ),
        //   userId: appUser?.id,
        //   productIds: products.map((e) => e.id),
        // });
        // void track('prescription upload', {
        //   uploaded_prescription_amount: pendingPrescriptions.length,
        //   products_amount: products.length,
        //   prescription_types: Array.from(
        //     new Set(products.map((e) => e.prescriptionType)) ?? [],
        //   ),
        // });
        if (!loadingCurrentOrder && !prescriptionLoading && !requirePrescriptions && redirectOnNonePending) {
            setTimeout(function() {
                void router.replace((0,utils/* getRoute */.Bv)("checkout", code ? {
                    codigo: codeString
                } : {}));
            }, 300);
        }
    }, [
        error,
        loadingCurrentOrder,
        router,
        products,
        pendingPrescriptions === null || pendingPrescriptions === void 0 ? void 0 : pendingPrescriptions.length,
        currentOrder,
        appUser,
        redirectOnNonePending,
        code,
        codeString,
        prescriptionLoading,
        requirePrescriptions, 
    ]);
    var hasInsurance = Boolean(currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.metadata) === null || ref === void 0 ? void 0 : ref.insuranceInfo);
    var loading = prescriptionLoading || loadingCurrentOrder || loadingUser;
    var headerTitle = isDesktop ? null : isLocalVendor ? "Pedir receta" : "Subir receta";
    var productsByPrescription = Object.entries(productsByPrescriptionType !== null && productsByPrescriptionType !== void 0 ? productsByPrescriptionType : {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {
                mobileColor: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader/* SimpleHeader */.A, {
                title: headerTitle,
                homeButton: Boolean(isDesktop),
                backButton: true,
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* PageWrapper */.F, {
                addHeaderPadding: false,
                disableMobilePadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* HorizontalContainer */.bp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckoutCardsContainer */.Q9, {
                            children: [
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* CheckoutTitle */.A, {
                                    title: "Algunos productos necesitan receta"
                                }),
                                isLocalVendor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList, {
                                    productsByPrescription: productsByPrescription
                                }) : loadingUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}) : pendingPrescriptions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadImageContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* UploadImage */.z, {
                                            emptyImagesError: emptyImagesError,
                                            setEmptyImagesError: setEmptyImagesError,
                                            pendingPrescriptions: pendingPrescriptions,
                                            hasInsurance: hasInsurance
                                        }),
                                        hasInsurance && /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationBox/* InformationBox */.e, {
                                            information: "Para utilizar el seguro, debes tener receta para todos los medicamentos"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* SubmitButton */.Mm, {
                                    disabled: loading,
                                    onClick: handleNext,
                                    children: "Siguiente"
                                }),
                                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrescriptionsInfoCard, {})
                            ]
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrescriptionsInfoCard, {})
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 58055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LE": function() { return /* binding */ SubtitleTypography; },
/* harmony export */   "Os": function() { return /* binding */ ErrorTypography; },
/* harmony export */   "Q9": function() { return /* binding */ CheckoutCardsContainer; },
/* harmony export */   "bp": function() { return /* binding */ HorizontalContainer; },
/* harmony export */   "dP": function() { return /* binding */ TitleTypography; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18377);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29630);



var HorizontalContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "1200px",
        gap: "22px"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "0"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
        gap: "40px"
    }), _obj;
});
var CheckoutCardsContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "desktopPadding";
    }
})(function(param) {
    var theme = param.theme, desktopPadding = param.desktopPadding;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        maxWidth: "800px",
        width: "100%",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        gap: "16px",
        backgroundColor: "inherit",
        border: "none"
    }, theme.breakpoints.up("sm"), {
        padding: desktopPadding !== null && desktopPadding !== void 0 ? desktopPadding : "24px",
        gap: desktopPadding !== null && desktopPadding !== void 0 ? desktopPadding : "24px"
    });
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "27px",
    letterSpacing: "0.15px"
});
var SubtitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0.15px",
    padding: "8px"
});
var ErrorTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "16px",
        letterSpacing: "0.15px",
        color: theme.palette.error.main
    };
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8203,1533,9388,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(20397); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);